module.exports = __webpack_public_path__ + "static/media/pageshield.e2fdfec9.jpeg";